<template>
  <form :class="{ dirty: $v.$anyDirty }" autocomplete="off" class="create-or-edit-topic-form" @submit.prevent="submit">
    <div class="form-row">
      <p-text-field v-model="title" :label="'Title'" autocomplete="off" />
      <ul v-if="$v.title">
        <li v-if="!$v.title.required" class="error">Title is required</li>
      </ul>
    </div>
    <div class="form-row">
      <p-text-field v-model="description" :label="'Description'" autocomplete="off" :multiline="true" />
    </div>

    <div v-if="isRequestFailed" class="error">
      Failed to save a topic. Check your input and try again.
    </div>
    <div class="form-row submit">
      <p-button type="button" @click.prevent="$router.back()">Cancel</p-button>
      <p-button color="primary" type="submit" :disabled="isRequestPending || ($v.$anyDirty && $v.$invalid)"
        >Save</p-button
      >
    </div>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

import TextField from '@/components/common/TextField';
import Button from '@/components/common/Button';

export default {
  components: {
    'p-text-field': TextField,
    'p-button': Button
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    isRequestPending: {
      type: Boolean,
      default: false
    },
    isRequestFailed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    if (this.item) {
      return {
        title: this.item.title,
        description: this.item.description
      };
    }
    return {
      title: '',
      description: ''
    };
  },
  computed: {},
  validations() {
    return {
      ...(this.item === null ? { title: { required } } : {})
    };
  },
  methods: {
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit('submit', {
        title: this.title.trim(),
        description: this.description.trim()
      });

      this.$v.$reset();
    }
  }
};
</script>

<style lang="scss" scoped>
.create-or-edit-topic-form {
  max-width: 640px;

  > div {
    min-width: 0;
    min-height: 0;
  }

  > div {
    &:not(:last-child) {
      margin-bottom: 1.5rem;
    }
    &:last-child {
      display: flex;
      justify-content: flex-end;
    }
  }

  .error {
    font-size: 0.8rem;
    color: var(--theme-error);
    text-align: left;
    padding: 0.25rem 0;
    display: none;
  }
  &.dirty {
    .error {
      display: block;
    }
  }
}
</style>
